const getSortedSlides = segments => {
  let slides = [];
  segments.forEach(segment => {
    slides.push(...segment.screens);
  });
  return slides;
};

const updateSegmentsTransition = segments => {
  let slides = getSortedSlides(segments);
  slides.forEach((s, i) => {
    if (i > 0) {
      if (s.transition.in.includes('-in')) {
        slides[i - 1].transition.out = s.transition.in.replace('-in', '-out');
      } else {
        slides[i - 1].transition.out = '';
      }
    }
  });

  return segments.map(segment => {
    segment.screens = segment.screens.map(screen => {
      screen.transition.out = slides.find(s => s.uid === screen.uid).transition.out;
      return screen;
    });
    return segment;
  });
};

export { updateSegmentsTransition };



// WEBPACK FOOTER //
// ./src/helpers/transition-handler.js